module.exports = __webpack_public_path__ + "static/img/3.940fbd2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/sp/3.png
// module id = blKD
// module chunks = 0